import name from './name'

const selectSliceData = state => state[name]
const selectSkillBiteList = state => selectSliceData(state).list
const selectTotal = state => selectSliceData(state).total

export {
  selectSkillBiteList,
  selectTotal
}
